import { create } from 'zustand';

export interface ConfirmRequest {
  title: string;
  message?: string;
  confirmLabel?: string;
  tone?: 'default' | 'danger';
}

export interface PromptRequest {
  title: string;
  label?: string;
  initialValue?: string;
  placeholder?: string;
  confirmLabel?: string;
}

type Pending =
  | { kind: 'confirm'; request: ConfirmRequest; resolve: (ok: boolean) => void }
  | { kind: 'prompt'; request: PromptRequest; resolve: (value: string | null) => void };

interface DialogState {
  pending: Pending | null;
}

export const useDialogs = create<DialogState>(() => ({ pending: null }));

/** Asks the user to confirm an action; resolves to whether they did. */
export function confirmDialog(request: ConfirmRequest): Promise<boolean> {
  return new Promise((resolve) => {
    useDialogs.setState({ pending: { kind: 'confirm', request, resolve } });
  });
}

/** Asks the user for a line of text; resolves to null if they cancel. */
export function promptDialog(request: PromptRequest): Promise<string | null> {
  return new Promise((resolve) => {
    useDialogs.setState({ pending: { kind: 'prompt', request, resolve } });
  });
}
